import { React } from 'react'
// import './services.css'
import { icap, tr, slug } from '../../../global-pure.js'
import PageLayout from '../../../containers/page/PageLayout.jsx'
import { card as ccsCard } from './ccs/Job.jsx'
import Card from '../../../components/card/Card.jsx'
import cardPic from '../../../assets/jobs/cleaning.jpg'

export const card = {
  title: 'cleaning:title',
  blurb: 'cleaning:blurb',
  subtitle: 'cleaning:subtitle',
  routeBuilder: () => `/${slug(tr('jobs'))}/${slug(tr('cleaning'))}`,
  imgUrl: cardPic,
  call: 'see jobs',
  // ask: <AskLink text={'purchase now'} prefill={'ant-s19j:question'} />
}

const Delivery = () => {
  return (
    <PageLayout>
      <div className='content'>
        <h1>{icap(tr('cleaning jobs'))}</h1>
        <Blog />
      </div>
    </PageLayout>
  )
}

const Blog = () => {
  return (
    <div className='dnc__blog-container'>
      <div className='dnc__blog-course_groupB'>
        <Card card={ccsCard} />
      </div>
    </div>
  )
}

export default Delivery